/* eslint-disable react-hooks/rules-of-hooks */
import { Button, Form, Row, Col, Modal, Input, Select, Alert } from "antd";
import { closeOcurrence } from "../../app/orders/api";
import { useState } from "react";
import { useFetchOrdersEditedById, useStoreEditedOrders } from "../../app/orders/mutations";

const { TextArea } = Input;

export const OcurrenceModal = ({
  isModalVisible,
  selectedOcurrence,
  onCloseModal,
}) => {
  const [form] = Form.useForm();
  const [response, setResponse] = useState(null);
  const [isSendForm, setIsSendForm] = useState(false);
  const isEditedOcurrence = useFetchOrdersEditedById(
    selectedOcurrence?.idNovedad
  );

  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));
  const { username } = getEmail;

  const onCloseOcurrence = async (values) => {
    const ocurrencePayload = {
      id: selectedOcurrence.idNovedad,
      usuario_cierre: username,
      comentarios_cierre: values.comentarios,
    };

    await closeOcurrence(ocurrencePayload)
      .then((response) => {
        setResponse({ type: "success", message: response });
        setIsSendForm(true);
      })
      .catch((error) => {
        setResponse({ type: "error", message: error.response.data.result });
        setIsSendForm(true);
      });
  };

  const handleCloseModal = () => {
    setResponse(null);
    setIsSendForm(false);
    onCloseModal();
    form.setFieldValue("comentarios", null);
    isSendForm && useStoreEditedOrders(selectedOcurrence?.idNovedad);
  };

  return (
    <Modal
      title="Cerrar Novedad"
      open={isModalVisible}
      onCancel={() =>
        handleCloseModal()
      }
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      {isEditedOcurrence && (
        <Alert message={`La novedad ya fue cerrada previamente. Si desea puede actualizar la consulta para ver los últimos cambios.`} type="success" />
      )}

      {isSendForm && response && (
        <div className="success-call-alert">
          <Alert message={response.message} type={response.type} />
        </div>
      )}
      {!isSendForm && !isEditedOcurrence && (
        <Form
          form={form}
          autoComplete="off"
          name="ocurrenceForm"
          layout="vertical"
          onFinish={onCloseOcurrence}
          id="ocurrenceForm"
        >
          <Row>
            <Col style={{ width: "50%" }}>
              <Form.Item
                name="ordenCompra"
                rules={[{ required: false, message: "requerido" }]}
                label="Estado"
              >
                <Select
                  showSearch
                  size="medium"
                  placeholder="CERRADA"
                  disabled={true}
                  options={[
                    {
                      value: "CERRADA",
                      label: "CERRADA",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="form--first-row" style={{ marginBottom: 15 }}>
            <Col className="gutter-row" style={{ width: "100%" }}>
              <Form.Item
                name="comentarios"
                label="Comentarios"
                rules={[{ required: true, message: "Requerido" }]}
              >
                <TextArea rows={4} showCount />
              </Form.Item>
            </Col>
          </Row>
          <Row
            className="form--first-row"
            style={{
              marginBottom: 15,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Col className="gutter-row">
              <Form.Item>
                <Button
                  type="default"
                  className="btn-primary"
                  size="medium"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Cerrar Novedad
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
};
